import { getCurrentGender } from "@multimediallc/gender-utils"
import { applyStyles } from "../../../../common/DOMutils"
import { dom } from "../../../../common/tsxrender/dom"
import { ResultType } from "../constants"
import { InputSuggestions } from "../inputSuggestions"
import { MobileSearchPaneHashtagSuggestedItem } from "./mobileSearchPaneHashtagSuggestedItem"
import { MobileSearchPaneHistorySuggestedItem } from "./mobileSearchPaneHistorySuggestedItem"
import { MobileSearchPaneKeywordsSuggestedItem } from "./mobileSearchPaneKeywordsSuggestedItem"
import { MobileSearchPaneOfflineSuggestedItem } from "./mobileSearchPaneOfflineSuggestedItem"
import { MobileSearchPaneOnlineSuggestedItem } from "./mobileSearchPaneOnlineSuggestedItem"
import type { IInputSuggestionsProps } from "../inputSuggestions"

export class MobileSearchPaneInputSuggestions extends InputSuggestions {
    private mobileAdvancedOptionsContainer: HTMLDivElement

    protected createElement(props: IInputSuggestionsProps): HTMLDivElement {
        return <div className="SearchPane__suggestionsDiv" />
    }

    protected initData(props: IInputSuggestionsProps): void {
        super.initData(props)

        const optionsContainer = document.getElementById("mobile_advanced_options_container")
        if (optionsContainer instanceof HTMLDivElement) {
            optionsContainer.dataset.testid = "advanced-search-options-component"
            this.mobileAdvancedOptionsContainer = optionsContainer
        }
    }

    public hideSuggestions(): void {
        super.hideSuggestions()
        applyStyles(this.mobileAdvancedOptionsContainer, { overflow: "hidden" })
    }

    public showSuggestions(): void {
        super.showSuggestions()
        applyStyles(this.mobileAdvancedOptionsContainer, { overflow: this.suggestionsList.length ? "visible" : "hidden" })
    }

    protected createSuggestion(labelText: string, input: string, resultType: ResultType, count: number, historyType?: ResultType): void {
        let suggestion: HTMLElement
        let href = `/${labelText}/`
        this.gender = getCurrentGender()

        const getProps = () => ({ labelText, input, count, href, resultType })
        switch (resultType) {
            case ResultType.Online:
                suggestion = new MobileSearchPaneOnlineSuggestedItem(getProps()).element
                break
            case ResultType.Offline:
                suggestion = new MobileSearchPaneOfflineSuggestedItem(getProps()).element
                break
            case ResultType.Hashtag:
                href = this.createUrlForHashtagSuggestion(labelText)
                suggestion = new MobileSearchPaneHashtagSuggestedItem(getProps()).element
                suggestion.dataset.testid = "search-hashtag-suggestion"
                break
            case ResultType.Keywords:
                href = this.createUrlForKeywordsSuggestion(input)
                suggestion = new MobileSearchPaneKeywordsSuggestedItem(getProps()).element
                suggestion.dataset.testid = "search-keywords-suggestion"
                break
            default:
                if (historyType === ResultType.Hashtag) {
                    href = this.createUrlForHashtagSuggestion(labelText.replace("#", ""))
                } else if (historyType === ResultType.History) {
                    href = ""
                }
                suggestion = new MobileSearchPaneHistorySuggestedItem(getProps()).element
                break
        }
        this.element.appendChild(suggestion)
        // Hover events
        const row = suggestion.firstElementChild as HTMLDivElement
        row.onmouseenter = () => {
            this.styleInactiveLastSug()
            this.styleActiveSuggestion(row)
            const strIndex = suggestion.getAttribute("index")
            if (strIndex !== null) {
                this.currentIndex = parseInt(strIndex, 10)
            }
            this.keyNavigated = false
        }
        row.onmouseleave = () => {
            this.styleInactiveLastSug()
            this.styleInactiveSuggestion(row)
            this.currentIndex = -1
            this.keyNavigated = false
        }
        this.suggestionsList.push({ label: labelText, element: row, resultType })
    }
}
